import React from 'react';
import styled from 'styled-components/macro';
import { Link as LinkInternal } from 'components/atoms';
import { handleEvent, POPULAR_SEARCHES_LINK_EVENT } from 'utils/Analytics';

interface Props {
  popularSearches?: State.InternalLink[] | null;
}

export const PopularSearches: React.FC<Props> = ({ popularSearches }) => {
  const handleLinkClick = React.useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    const eventTarget = event.target as HTMLAnchorElement;
    handleEvent({ text: eventTarget.text, href: eventTarget.href }, POPULAR_SEARCHES_LINK_EVENT);
  }, []);
  if (!popularSearches || !popularSearches.length) {
    return null;
  }
  return (
    <PopularSearch>
      <PopularTitle>Popular searches</PopularTitle>
      {popularSearches.map(popular => (
        <PopularItem
          key={`popularSearchListItem${popular.name}`}
          to={popular.url}
          onClick={handleLinkClick}
          testId={`popularSearchListItem${popular.name}`}
        >
          {popular.name}
        </PopularItem>
      ))}
    </PopularSearch>
  );
};

const PopularSearch = styled.div`
  margin-bottom: ${props => props.theme.pxToRem(32)};
`;

const PopularTitle = styled.div`
  font-size: ${props => props.theme.fontSizes.m};
  font-weight: ${props => props.theme.fontWeights.light};
  line-height: 1.33;
  color: ${props => props.theme.colors.neutralGrey8};
`;

const PopularItem = styled(LinkInternal)`
  display: block;
  padding-top: 0.5rem;
  font-size: ${props => props.theme.fontSizes.xs};
  font-weight: ${props => props.theme.fontWeights.medium};
  line-height: 1.57;

  &:hover {
    text-decoration: underline;
    color: ${props => props.theme.colors.primaryPurple};
  }
`;
